$(document).ready(function () {

	//
	// Define tags and their events to prevent the default for
	let preventDefault = {
		'a':		'click',
		'button':	'click',
		'*':		'click',
	}

	//
	// Iterate through all tags to apply the events
	for (let tag in preventDefault) {

		//
		// Store the event and the node information
		let trigger	= preventDefault[tag];
		let node	= tag + '[nolink]'

		//
		// Apply event
		$(document).on(trigger, node, (event) => {
			event.originalEvent.preventDefault();
			event.preventDefault();
		});
	}

	$(document).on('click', '*[data-href]', function (event) {
		const emptyHref	= $(event.target).closest('[data-href]').attr('data-href').length == 0;
		const noHref	= $(event.target).closest('.nohref').length > 0;
		if (emptyHref || noHref) {
			return;
		}

		window.location = $(this).data('href');
		return false;
	});
});
